export interface EmployeeRoleType {
  value: string;
  label: { fr: string; en: string };
}

export const EMPLOYEE_ROLE_TYPES: EmployeeRoleType[] = [
  { value: "landSurveyor", label: { fr: "Arpenteur-Géomètre", en: "Land Surveyor-Geomatics" } },
  { value: "projectManager", label: { fr: "Chargé de projet", en: "Project Manager" } },
];
